import { Group, Tooltip, ActionIcon } from "@mantine/core";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { Link } from "react-router-dom";

export function TableActions({ children }) {
  return (
    <Group justify="right" wrap="nowrap" gap="xs">
      {children}
    </Group>
  );
}

export function TableAction({ label, icon: Icon, color, ...actionIconProps }) {
  return (
    <Tooltip label={label}>
      <ActionIcon size="md" variant="light" color={color} {...actionIconProps}>
        <Icon size={20} />
      </ActionIcon>
    </Tooltip>
  );
}

export function EditAction({ to, label = "Edit" }) {
  return <TableAction label={label} icon={IconEdit} component={Link} to={to} />;
}

export function DeleteAction({ onDelete, label = "Delete", disabled }) {
  return (
    <TableAction
      label={label}
      icon={IconTrash}
      color="red"
      onClick={onDelete}
      disabled={disabled}
    />
  );
}

export function actionsColumn(render, overrides = {}) {
  return {
    accessor: "actions",
    textAlign: "right",
    width: "0%",
    render,
    ...overrides,
  };
}
